import React, { useState } from 'react';
import axios from 'axios';
import {
  Carousel,
  Button,
  Spinner,
  Alert,
  Card,
  Row,
  Col,
  ListGroup,
} from 'react-bootstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';

const SingleProduct = ({ product, onSuccess }) => {
  const [currentProduct, setCurrentProduct] = useState(product);
  const [updating, setUpdating] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [showToast, setShowToast] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';
  if (!currentProduct) return <p>No product selected.</p>;

  const images = Array.isArray(currentProduct?.images) ? currentProduct.images : [];

  const handleApprove = async () => {
    setUpdating(true);
    try {
      await axios.put(
        `${API_BASE_URL}/admin/${currentProduct.id}/status`,
        { status: 'For Sale' },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      setCurrentProduct(prev => ({
        ...prev,
        status: 'For Sale',
      }));
      setToastMessage('Product approved successfully!');
      setToastVariant('success');
      
      // Trigger parent refresh
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error(err);
      setToastMessage('Failed to update product status.');
      setToastVariant('danger');
    } finally {
      setShowToast(true);
      setUpdating(false);
    }
  };

  const handleRejectClick = () => {
    setRejectModal(true);
  };

  const handleReject = async () => {
    if (!rejectionReason.trim()) {
      setToastMessage('Please provide a reason for rejection.');
      setToastVariant('danger');
      setShowToast(true);
      return;
    }

    setUpdating(true);
    try {
      await axios.put(
        `${API_BASE_URL}/admin/${currentProduct.id}/status`,
        { status: 'Rejected', rejectionReason: rejectionReason.trim() },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      setCurrentProduct(prev => ({
        ...prev,
        status: 'Rejected',
      }));
      setToastMessage('Product rejected successfully!');
      setToastVariant('success');
      setRejectModal(false);
      setRejectionReason('');
      
      // Trigger parent refresh
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error(err);
      setToastMessage('Failed to reject product.');
      setToastVariant('danger');
    } finally {
      setShowToast(true);
      setUpdating(false);
    }
  };
  // Place this above the return or JSX
if (currentProduct?.isAuction && currentProduct?.auction) {
  console.log('Auction Debug:', {
    isAuction: currentProduct.isAuction,
    auction: currentProduct.auction
  });
}

console.log("Initial Product Data:", product);
console.log("Current Product State:", currentProduct);


  return (
    <div className="container py-4">
      {/* Toast */}
      {showToast && (
        <div
          style={{
            position: 'fixed',
            top: 20,
            right: 20,
            zIndex: 9999,
            minWidth: '300px',
          }}
        >
          <Alert
            variant={toastVariant}
            onClose={() => setShowToast(false)}
            dismissible
          >
            {toastMessage}
          </Alert>
        </div>
      )}

      {/* Image Carousel */}
      <Card className="mb-4 shadow-sm">
        {images.length > 0 ? (
          <Carousel>
            {images.map((img, idx) => (
              <Carousel.Item key={idx}>
                <img
                  className="d-block w-100"
                  src={img.fileUrl}
                  alt={`Slide ${idx + 1}`}
                  style={{ height: '400px', objectFit: 'cover', cursor: 'pointer' }}
                  onClick={() => window.open(img.fileUrl, '_blank')}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div
            className="d-flex align-items-center justify-content-center bg-secondary text-white"
            style={{ height: '400px' }}
          >
            No images available
          </div>
        )}
      </Card>

      {/* Product Info */}
      <Card className="mb-3 shadow-sm">
        <Card.Header as="h5">{currentProduct.name}</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <ListGroup variant="flush">
                <ListGroup.Item><strong>Title:</strong> {currentProduct.title}</ListGroup.Item>
                <ListGroup.Item><strong>Description:</strong> {currentProduct.description || 'N/A'}</ListGroup.Item>
                <ListGroup.Item><strong>Category:</strong> {currentProduct.category}</ListGroup.Item>
                <ListGroup.Item><strong>Condition:</strong> {currentProduct.condition}</ListGroup.Item>
                <ListGroup.Item><strong>Brand:</strong> {currentProduct.brand}</ListGroup.Item>
                <ListGroup.Item><strong>Year of Purchase:</strong> {currentProduct.yearOfPurchase}</ListGroup.Item>
                <ListGroup.Item><strong>Usage:</strong> {currentProduct.usage}</ListGroup.Item>
              </ListGroup>
            </Col>
            <Col md={6}>
              <ListGroup variant="flush">
                <ListGroup.Item><strong>Price:</strong> ${currentProduct.price}</ListGroup.Item>
                <ListGroup.Item>
                  <strong>Location:</strong>{' '}
                  {currentProduct.location && typeof currentProduct.location === 'object'
                    ? `${currentProduct.location.lat}, ${currentProduct.location.lng}`
                    : currentProduct.location || 'N/A'}
                </ListGroup.Item>
                <ListGroup.Item><strong>Status:</strong> {currentProduct.status}</ListGroup.Item>
                <ListGroup.Item><strong>Seller:</strong> {currentProduct.seller?.fullName || 'N/A'}</ListGroup.Item>
                <ListGroup.Item><strong>Created:</strong> {new Date(currentProduct.createdAt).toLocaleString()}</ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>

  {currentProduct?.isAuction && (
  <Card className="mb-3 shadow-sm">
    <Card.Header as="h5">Auction Details</Card.Header>
    <Card.Body>
      <Row>
        <Col md={6}>
          <p><strong>Starting Price:</strong> ${currentProduct.startingPrice ?? 'N/A'}</p>
          <p><strong>Reserve Price:</strong> ${currentProduct.reservePrice ?? 'N/A'}</p>
        </Col>
        <Col md={6}>
          <p><strong>Auction Start:</strong> 
            {currentProduct.bidStartDate 
              ? new Date(currentProduct.bidStartDate).toLocaleString() 
              : 'N/A'}
          </p>
          <p><strong>Duration (hrs):</strong> {currentProduct.duration ?? 'N/A'}</p>
        </Col>
      </Row>
    </Card.Body>
  </Card>
)}





      {/* Approve/Reject Buttons */}
      {currentProduct.status?.toLowerCase() === 'pending' && (
        <div className="mb-3 d-flex gap-2">
          <Button variant="success" onClick={handleApprove} disabled={updating}>
            {updating ? (
              <>
                <Spinner animation="border" size="sm" /> Approving...
              </>
            ) : (
              'Approve'
            )}
          </Button>
          <Button variant="danger" onClick={handleRejectClick} disabled={updating}>
            Reject
          </Button>
        </div>
      )}

      {/* Reject Modal */}
      <Modal isOpen={rejectModal} toggle={() => setRejectModal(!rejectModal)} size="lg">
        <ModalHeader toggle={() => setRejectModal(!rejectModal)}>Reject Listing</ModalHeader>
        <ModalBody>
          <p>Please provide a reason for rejecting this listing. This reason will be sent to the seller.</p>
          <Input
            type="textarea"
            rows="5"
            placeholder="Enter rejection reason..."
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            disabled={updating}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => {
            setRejectModal(false);
            setRejectionReason('');
          }} disabled={updating}>
            Cancel
          </Button>
          <Button color="danger" onClick={handleReject} disabled={updating || !rejectionReason.trim()}>
            {updating ? (
              <>
                <Spinner size="sm" /> Rejecting...
              </>
            ) : (
              'Reject Listing'
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SingleProduct;
